export default __webpack_public_path__ + "static/media/headshot.be83a85f.jpeg";